<template>
  <!--新增弹出框-->
  <el-dialog
    :visible.sync="addVisible"
    title="舱位选择"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthAdd"
  >
    <div class="container">
      <!-- 确认 start -->
      <el-row :gutter="10" class="content-panel title-fix">
        <el-form label-position="top" size="mini" :model="csCust"
                 :validateOnRuleChange="false" ref="ruleFormRef" :rules="rulesForm">
          <el-col :span="20">
            <el-form-item prop="carrierName">
              <el-associate style="width: 100%;"
                            :columns="associate_columns_carrier"
                            :query-method="associate_queryMethod_carrier"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="custNameCn"
                            value-prop="custNameCn"
                            placeholder="请输入舱位公司"
                            v-model="csCust.carrierName"
                            size="mini"
                            @change="onChangeCarrier"
              />
            </el-form-item>
          </el-col>
        </el-form>
        <el-col :span="4">
          <el-row>
            <el-button type="primary" size="small" plain @click="sure">确认</el-button>
          </el-row>
        </el-col>
      </el-row>
      <!-- 确认 end -->
      <!-- 最近使用 start -->
      <el-row :gutter="10" class="content-panel title-fix" style="margin-top: 10px">
        <el-row style="margin-bottom: 10px">
          <el-col :span="10">
            <span>最近使用舱位公司</span>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="height: 100px">
          <el-col v-for="(item,index) in lastCustList" v-if="index<4" :span="6">
            <el-row>
              <img style="width:80px;height:80px"
                   src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.51yuansu.com%2Fpic3%2Fcover%2F01%2F67%2F41%2F595823a948576_610.jpg&refer=http%3A%2F%2Fpic.51yuansu.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1621262759&t=02c0b693b227765940e023586f9fb3ad"
                   :alt="item.custName"
                   @click="linkTo(item)"/>
            </el-row>
            <el-row>
              <span>{{item.custName}}</span>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="height: 100px">
          <el-col v-for="(item,index) in lastCustList" v-if="index>3" :span="6">
            <el-row>
              <img style="width:80px;height:80px"
                   src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.51yuansu.com%2Fpic3%2Fcover%2F01%2F67%2F41%2F595823a948576_610.jpg&refer=http%3A%2F%2Fpic.51yuansu.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1621262759&t=02c0b693b227765940e023586f9fb3ad"
                   :alt="item.custName"
                   @click="linkTo(item)"/>
            </el-row>
            <el-row>
              <span>{{item.custName}}</span>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
      <!-- 最近使用 end -->
    </div>
  </el-dialog>
</template>

<script>
  import {queryCarrierInfo} from "@/api/commonService";
  import ebOrder from "@/api/ebOrder";

  export default {
    name: 'addUpBox',
    props: {
      addVisibleFlagInit: Boolean,
      ebOrder: {}
    },
    data() {
      return {
        addVisible: false,
        csCust: {
          carrierId: '',
          carrierName: ''
        },
        //最近使用的舱位公司
        lastCustList: [],
        //非空校验
        rulesForm: {
          carrierName: [{
            required: true,
            message: "请选择一个舱位公司",
            trigger: ['blur', 'change']
          }]
        },
        // 舱位公司联想控件
        associate_columns_carrier: [
          {
            title: "客商简称",
            field: 'custAlias'
          },
          {
            title: "客商全称",
            field: 'custNameCn'
          },
          {
            title: "助记码",
            field: 'mnemonicCode'
          }
        ],
      }
    },
    // 监听
    watch: {
      addVisibleFlagInit() {
        let self = this
        self.addVisible = true
        console.log("self.ebOrder", self.ebOrder)
      }
    },
    async created() {

    },
    mounted() {
      let self = this
      self.getLastCust()
    },
    methods: {
      // 舱位公司联想控件数据源
      associate_queryMethod_carrier({keyword, pageSize, currentPage}) {
        let params = {}
        if (keyword === '') {
          params = {
            custType4: "%SO%",
            isDeleted6: "0"
          }
        } else {
          params = {
            custAlias0: "%" + keyword + "%",
            custNameCn1: "%" + keyword + "%",
            custType4: "%SO%",
            isDeleted6: "0",
            mdmCustCode3: "%" + keyword + "%",
            mnemonicCode2: "%" + keyword + "%",
          }
        }

        let data =
          {
            action: "query",
            crudType: "SELECT",
            sorting: ["CTS_ILPCsCust.custNameCn"],
            mainModelName: "CTS_ILPCsCust",
            tag: "CTS_WEB_es",
            where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
            currentPage: currentPage,
            pageSize: pageSize,
            returnPage: true,
            returnTotal: false,
            reqArgs: params,
            fields: [
              "CTS_ILPCsCust.csCustId",
              "CTS_ILPCsCust.custAlias",
              "CTS_ILPCsCust.custNameCn",
              "CTS_ILPCsCust.custNameEn",
              "CTS_ILPCsCust.customsRegisteredNo",
              "CTS_ILPCsCust.esCustType",
              "CTS_ILPCsCust.isActive",
              "CTS_ILPCsCust.isBlacklist",
              "CTS_ILPCsCust.isCustomer",
              "CTS_ILPCsCust.isDeleted",
              "CTS_ILPCsCust.isOneTimeCustomer",
              "CTS_ILPCsCust.isSettlement",
              "CTS_ILPCsCust.isSupplier",
              "CTS_ILPCsCust.legalPerson",
              "CTS_ILPCsCust.mdmCustCode",
              "CTS_ILPCsCust.mobileNo",
              "CTS_ILPCsCust.postCode"
            ],
            enableCascade: true
          }
        return new Promise(resolve => {
          queryCarrierInfo(data).then(res => {
            console.log("queryCarrierInfo", res)
            resolve({
              records: res.data.data,
              total: res.data.totalRecord
            })
          })
        }).catch(err => {
          console.log(err)
        })
      },
      // 船公司联想控件改变事件
      onChangeCarrier(value, selectedRows) {
        this.csCust = {
          carrierId: selectedRows.csCustId,
          carrierName: selectedRows.custNameCn,
        }
        console.log("selectedRows", selectedRows);
      },
      //确认
      sure() {
        let self = this
        //非空校验
        self.$refs.ruleFormRef.validate(async valid => {
          if (valid) {
            self.ebOrder.carrierId = self.csCust.carrierId
            self.ebOrder.carrierName = self.csCust.carrierName
            console.log("AddUpBox-self.ebOrder:",self.ebOrder)
            self.$router.push({
              name: "bookingAdd",
              params: {
                ebOrder: self.ebOrder,
              }
            })
          }
        })
        this.addVisible = !this.addVisible
      },
      //关闭
      close() {
        let self = this
        self.addVisible = false
      },
      //最近使用过的舱位公司
      getLastCust() {
        ebOrder.getLastCust().then(res => {
          console.log("getLastCust", res)
          this.lastCustList = res.data
        })
      },
      //点击跳转
      linkTo(data) {
        this.ebOrder.carrierId = data.carrierId
        this.ebOrder.carrierName = data.carrierName
        this.$router.push({
          name: "bookingAdd",
          params: {
            ebOrder: this.ebOrder,
          }
        })
        this.addVisible = !this.addVisible
      }
    }
  }
</script>

<style>
  .customWidthAdd {
    width: 50%;
  }

  .el-dialog__body {
    padding: 0px;
  }

</style>
